import OrganizationProfile from "./OrganizationProfile";
import Region from "./Region";
import PublishToBlockchain from "./PublishToBlockchain";
import { Navigate } from "react-router";

export const organizationSetupRoutes = {
    DEFAULT_PAGE: {
        name: "default",
        path: "",
        element: <Navigate to="profile" replace />,
        index: true,
    },
    ORGANIZATION_PROFILE: {
        name: "organizationprofile",
        path: "profile",
        element: <OrganizationProfile />,
    },
    REGION: {
        name: "region",
        path: "region",
        element: <Region />,
    },
    PUBLISH_TO_BLOCKCHAIN: {
        name: "publishtoblockchain",
        path: "publish",
        element: <PublishToBlockchain />,
    },
};

export const { DEFAULT_PAGE, ORGANIZATION_PROFILE, REGION, PUBLISH_TO_BLOCKCHAIN } =
    organizationSetupRoutes;
